<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 132.5,
      left: 171.61,
      width: 346.437,
      height: 750.933,
      rotation: 144.282,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: 213.2,
      left: 271.49,
      width: 247.313,
      height: 601.446,
      rotation: 111.905,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 55.84,
      left: 123.58,
      width: 326.094,
      height: 633.268,
      rotation: 7.627,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: -12.79,
      left: -113.97,
      width: 457.32,
      height: 939.82,
      rotation: 97.34,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--2', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="348"
    height="752"
    viewBox="0 0 348 752"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="173.832"
      cy="375.965"
      rx="173.218"
      ry="375.466"
      fill="url(#paint0_radial_5_2)" />
    <defs>
      <radialGradient
        id="paint0_radial_5_2"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-25.0471 751.019 -1863.92 -635.625 160.089 60.6683)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
